import { combineReducers } from '@reduxjs/toolkit';
import AsyncStatus from '@tgtg/core/async/AsyncStatus';
import AsyncStatusReducer from '@tgtg/core/async/AsyncStatusReducer';
import { LOGIN, LOGOUT } from '@tgtg/core/auth/types';

import type { UnknownAction } from '@reduxjs/toolkit';

const logoutReducer = AsyncStatusReducer.asEnum(LOGOUT);

const rootReducer = combineReducers({
  status: (state = AsyncStatus.NONE, action: UnknownAction) => {
    const { type } = action;
    if (type === LOGIN.SUCCESS) {
      return AsyncStatus.NONE;
    }
    return logoutReducer(state, { type });
  },
});

export default rootReducer;
